import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  Tooltip,
} from '@mui/material';

import { TextFieldsSectionProps } from '../types';

import styles from './text-fields-section.module.scss';


const TextFieldsSection: FC<TextFieldsSectionProps> = ({ control, errors, fields, titleKey = 'client.textSectionTitle' }) => {
  const { t } = useTranslation();

  return (
    <Box className={styles.formSection}>
      <Typography variant="h5" className={styles.sectionTitle}>{t(titleKey)}</Typography>
      <Grid container spacing={3}>
        {fields.map((fieldConfig) => (
          <Grid item key={fieldConfig.name} {...(fieldConfig.gridProps || { xs: 12 })}>
            <Controller
              name={fieldConfig.name}
              control={control}
              rules={{ required: fieldConfig.required ? t('client.validation.requiredField') : false }}
              render={({ field }) => (
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    {...field}
                    fullWidth
                    label={t(fieldConfig.label)}
                    placeholder={fieldConfig.placeholder ? t(fieldConfig.placeholder) : ''}
                    error={!!errors[fieldConfig.name]}
                    helperText={errors[fieldConfig.name]?.message as string}
                    size="medium"
                    disabled={fieldConfig.readOnly}
                    FormHelperTextProps={{ sx: { textAlign: 'center' } }}
                    InputProps={{
                      sx: {
                        '& input': { 
                          textAlign: 'center', 
                          fontSize: { xs: 12, sm: 13, md: 14 },
                          ...(fieldConfig.readOnly && {
                            backgroundColor: '#f5f5f5',
                            color: '#666',
                            cursor: 'not-allowed'
                          })
                        },
                        '& .MuiInputBase-input': { 
                          textAlign: 'center',
                          paddingTop: '16px',
                          paddingBottom: '16px',
                        },
                        minHeight: '56px', // Увеличиваем высоту полей
                      },
                      endAdornment: fieldConfig.tooltip && (
                        <Tooltip title={t(fieldConfig.tooltip)} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={3000}>
                          <IconButton size="small" sx={{ mr: -1, display: 'flex', alignItems: 'center' }}>
                            <InfoIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      ),
                    }}
                  />
                </Box>
              )}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TextFieldsSection; 